<template>

    <section class="c-settings_export">
        <h3>Eksport dokumentacji pacjenta</h3>
        <form @submit.prevent="submit('generate-file-form')" data-vv-scope="generate-file-form">
            <form-desc>Wygenerowana dokumentacja będzie obejmowała wizyty pasujące do ustawionych kryteriów. Dane
                zostaną zapisane w formacie pliku ZIP i będą zawierały uporządkowany podział wizyt na problemu oraz daty
                wraz dokumentacją w formacie PDF oraz załącznikami.
            </form-desc>
            <form-row>
                <form-select
                    label="Wybierz pacjenta"
                    :options="patientsList"
                    v-model="patientId"
                    data-vv-as="pacjent"
                    v-validate="'required'"
                    @input="fetchProblems">
                </form-select>
            </form-row>
            <div v-if="patientId">
                <form-row>
                    <form-switch
                        label="Ogranicz do problemu"
                        v-model="withIssue">
                    </form-switch>
                    <form-select
                        v-if="withIssue"
                        label="Wybierz problem"
                        :options="patientIssues"
                        v-model="issueId"
                        data-vv-as="problem"
                        v-validate="'required'">
                    </form-select>
                </form-row>
                <form-row>
                    <form-switch
                        label="Ogranicz do wybranego okresu"
                        v-model="withPeriod">
                    </form-switch>
                    <form-inline v-if="withPeriod">
                        <form-date
                            v-model="startDate"
                            type="date"
                            label="Data od"
                            data-vv-as="okres od"
                            v-validate="'required'">
                        </form-date>
                        <form-date
                            v-model="endDate"
                            type="date"
                            label="Data do"
                            :min-datetime="startDate"
                            data-vv-as="okres do"
                            v-validate="'required'">
                        </form-date>
                    </form-inline>
                </form-row>
                <form-row align="right">
                    <v-btn
                        type="green"
                        role="submit"
                        has-loader
                        :loading="isGenerating">
                        Generuj plik
                    </v-btn>
                </form-row>
            </div>
        </form>
    </section>

</template>


<script>

import moment from 'moment'
import {mapGetters} from 'vuex'
import {FormDesc, FormRow, FormInline, FormDate, FormSelect, FormSwitch} from 'Components/Form'
import VBtn from 'Components/VBtn'
import FileDownload from 'js-file-download'

export default {

    name: 'SettingsExport',

    data() {
        return {
            patientId: null,
            issueId: null,
            startDate: '',
            endDate: '',
            withIssue: false,
            withPeriod: false,
            isGenerating: false
        }
    },

    computed: {
        ...mapGetters(['patientsList', 'patientIssues']),
        safePatientName() {
            const patient = this.patientsList.filter((p) => {
                return p.id == this.patientId
            })[0] || {name: ''}
            const patientName = patient.name.toString()
            return patientName.replace(/[^a-z0-9]/gi, '_')
        },
        safeIssueName() {
            const issue = this.patientIssues.filter((p) => {
                return p.id == this.issueId
            })[0] || {name: ''}
            const issueName = issue.name.toString()
            return issueName.replace(/[^a-z0-9]/gi, '_')
        }
    },

    methods: {
        submit(scope) {
            this.$validator.validateAll(scope).then((isValid) => {
                if (isValid) {
                    this.isGenerating = true
                    this.exportDoc()
                } else {
                    this.isGenerating = false
                }
            })
        },
        exportDoc() {
            let query = {}
            if (this.withIssue)
                query.issue_id = this.issueId
            if (this.withPeriod) {
                query.start = this.startDate
                query.end = this.endDate
            }

            this.$store.dispatch('PHT_EXPORT_PATIENT_DOC', {
                patient_id: this.patientId,
                query: query
            }).then((res) => {
                this.isGenerating = false
                this.$alert.info('Załączniki', 'Za chwilę zacznie się pobieranie pliku')
                setTimeout(() => {
                    FileDownload(res.data, this.getFileName());
                }, 1000)
            }).catch((error) => {
                this.isGenerating = false
                this.$alert.error('Generowanie dokumentacji', error.response.data.message)
            })
        },
        fetchProblems() {
            this.$store.dispatch('PATIENT_ISSUES_FETCH', this.patientId)
        },
        getFileName() {
            let name = 'EDF'
            name += '-' + this.safePatientName

            if (this.withIssue)
                name += '-' + this.safeIssueName

            if (this.withPeriod)
                name += '-' + moment(this.startDate).format('YYYYMMDD') + '-' + moment(this.endDate).format('YYYYMMDD')

            name += '.zip'
            return name
        }
    },

    components: {
        VBtn,
        FormDesc,
        FormRow,
        FormInline,
        FormDate,
        FormSelect,
        FormSwitch
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-settings_export {

}

</style>
